export default __webpack_public_path__ + "static/char-s-15-jp-ad890b02cf4a289d33b4634d22eccec3.webp";